import { render } from "./CentralizeSimplifySection.vue?vue&type=template&id=4ec4efde&scoped=true"
import script from "./CentralizeSimplifySection.vue?vue&type=script&lang=js"
export * from "./CentralizeSimplifySection.vue?vue&type=script&lang=js"

import "./CentralizeSimplifySection.vue?vue&type=style&index=0&id=4ec4efde&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec4efde"]])

export default __exports__